import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { ContentFragment } from 'client/site-modules/shared/components/content-fragment/content-fragment';
/* Constants */
import {
  PRIVATE_PARTY_SELL_CAR_CTA,
  CREATIVE_ID_ENTRY_PRIVATE_PARTY,
  PRIVATE_PARTY_SELL_CAR_TED7310,
} from 'site-modules/shared/constants/private-party/private-party';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { venomHistory } from 'client/utils/history/venom-history';
import { getCreateListingUrl } from 'site-modules/shared/utils/private-party/private-party';
/* Tracking */
import { EventToolbox } from 'client/utils/event-toolbox';
import { EngagementHandler } from 'client/engagement-handlers';
import { PrivatePartyEngagementHandler } from 'client/engagement-handlers/private-party-engagement-handler/private-party-engagement-handler';

import './private-party-sell-car.scss';

EngagementHandler.register(PrivatePartyEngagementHandler);

export function PrivatePartySellCar({ creativeId = CREATIVE_ID_ENTRY_PRIVATE_PARTY, activeTabLabel = '' }) {
  const { imageSrc, benefits, header } = PRIVATE_PARTY_SELL_CAR_TED7310.chal1;
  const url = getCreateListingUrl();

  const handleClick = useCallback(() => {
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.START_PP_LISTING, {
      value: activeTabLabel || PRIVATE_PARTY_SELL_CAR_CTA,
      creativeId,
    });

    venomHistory.push(url);
  }, [activeTabLabel, creativeId, url]);

  return (
    <div
      data-tracking-parent={CREATIVE_ID_ENTRY_PRIVATE_PARTY}
      className="private-party-entry-point-wrapper ted7310chal1 bg-cool-gray-90 mt-auto"
    >
      <Button
        className="text-decoration-none text-decoration-none-hover text-transform-none fw-normal d-flex justify-content-between align-items-center w-100 btn-wrapper py-1 px-1_5 p-lg-0_75 ps-lg-1"
        onClick={handleClick}
        color="link"
      >
        <div className="d-flex">
          <img src={getStaticImageUrl(imageSrc)} width={40} alt="" loading="lazy" />
          <div className="me-1 d-block text-start size-16 text-wrap text-md-nowrap ms-1 ms-md-0_75">
            <ContentFragment classes="fw-bold mb-0_25">{header}</ContentFragment>
            <ul className="ps-1 ps-lg-0 benefits-list size-14 mb-0 d-lg-flex text-start">
              {benefits.map((benefit, index) => (
                <ContentFragment key={`benefit_${index + 1}`} classes="benefit-item pe-md-2" componentToUse="li">
                  {benefit}
                </ContentFragment>
              ))}
            </ul>
          </div>

          <i className="icon-arrow-right4 text-primary" aria-hidden />
        </div>
      </Button>
    </div>
  );
}

PrivatePartySellCar.propTypes = {
  creativeId: PropTypes.string,
  activeTabLabel: PropTypes.string,
};
